import React, { useState } from 'react';
import { FormattedHTMLMessage, FormattedMessage } from 'react-intl';
import styles from './voluntaryRegistration.module.scss';
import { ScrollView } from '../../ScrollView/ScrollView';
import { FixedHeader } from '../FixedHeader/FixedHeaader';
import { Footer } from '../Footer';
import { Button } from '../../form';
import { Popup, PopupButtons, PopupContent } from '../../Popup';
import moment from 'moment';
import { updateNemSmsContact } from '../../../services/nemsms.service';

interface IVoluntaryRegistraion {
    handleUserRegisteredWithIntorFlow: () => void;
    contactInformation: any;
}

export const VoluntaryRegistraion = (props: IVoluntaryRegistraion): JSX.Element => {
    const [isConfirmPuopup, setIsConfirmPopup] = useState<boolean>(false);
    const [isConfirmRegistrationPuopup, setIsConfirmRegistrationPuopup] = useState<boolean>(false);
    const { handleUserRegisteredWithIntorFlow, contactInformation } = props;

    const handleConfirmationClick = (isConfirm?: boolean) => {
        const toggleConfirm = !isConfirmPuopup;
        const toggleConfirmRegistration = !isConfirmRegistrationPuopup;
        setIsConfirmPopup(toggleConfirm);
        if (isConfirm) {
            const postData = {
                id: contactInformation.id,
                version: contactInformation.version,
                type: contactInformation.type,
                transactionId: contactInformation.transactionId,
                cprNumber: contactInformation.cprNumber,
                lastUpdated: contactInformation.lastUpdated,
                createdDate: contactInformation.createdDate,
                eligibleForVoluntaryRegistration: contactInformation.eligibleForVoluntaryRegistration,
                mailboxSubscription: {
                    registrationStatus: 'VOLUNTARY_REGISTRATION',
                    startTime: moment().toISOString(),
                },
            };
            updateNemSmsContact(postData, contactInformation.id).then((res) => {
                setIsConfirmRegistrationPuopup(toggleConfirmRegistration);
            });
        }
    };

    const handleRegistrationClick = (isRegister?: boolean) => {
        const toggleConfirmRegistration = !isConfirmRegistrationPuopup;
        if (isRegister) {
            setIsConfirmRegistrationPuopup(toggleConfirmRegistration);
            handleUserRegisteredWithIntorFlow();
        }
    };

    return (
        <div className="h-100 w-100">
            <ScrollView
                verticalOnly
                viewStyle={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                }}
            >
                <section className={styles.textLayout}>
                    <div className="d-flex flex-column flex-fill p-3 px-md-4 pb-md-4 pt-md-3">
                        <FixedHeader title={<FormattedMessage id="VOLUNTRY_REG_HEADER" />} />
                        <FormattedHTMLMessage tagName="div" id="VOLUNTRY_REG_DESCRIPTION" />
                        <FormattedHTMLMessage tagName="div" id="VOLUNTRY_REG_LINK" />
                        <div className="d-flex ml-auto mt-3">
                            <Button type="button" onClick={(): void => handleConfirmationClick()}>
                                <FormattedMessage id="VOLUNTRY_REG_BTN_TXT" />
                            </Button>
                        </div>
                    </div>
                </section>
                <Footer />
            </ScrollView>
            {isConfirmPuopup && (
                <Popup
                    show
                    headertext="VOLUNTRY_REG_CONFIRM_POPUP_HEADER"
                    onClosePopup={(): void => handleConfirmationClick()}
                >
                    <PopupContent className="d-flex flex-column my-3">
                        <FormattedHTMLMessage tagName="div" id="VOLUNTRY_REG_CONFIRM_POPUP_TXT" />
                    </PopupContent>
                    <PopupButtons className="justify-content-end pt-2">
                        <Button variant="secondary" className="mr-2" onClick={(): void => handleConfirmationClick()}>
                            <FormattedMessage id="VOLUNTRY_REG_CANCEL" defaultMessage="VOLUNTRY_REG_CANCEL" />
                        </Button>
                        <Button type="button" onClick={(): void => handleConfirmationClick(true)}>
                            <FormattedMessage id="VOLUNTRY_REG_CONFIRM_POPUP_BTN" />
                        </Button>
                    </PopupButtons>
                </Popup>
            )}
            {isConfirmRegistrationPuopup && (
                <Popup show headertext="VOLUNTRY_REG_POPUP_HEADER">
                    <PopupContent className="d-flex flex-column my-3">
                        <FormattedMessage id="VOLUNTRY_REG_POPUP_TXT" />
                    </PopupContent>
                    <PopupButtons className="justify-content-end pt-2">
                        <Button type="button" onClick={(): void => handleRegistrationClick(true)}>
                            <FormattedMessage id="VOLUNTRY_REG_POPUP_BTN" />
                        </Button>
                    </PopupButtons>
                </Popup>
            )}
        </div>
    );
};
